{
  "dropzoneLabel": "Strefa upuszczania",
  "selectPlaceholder": "Wybierz element",
  "tableResizer": "Zmiana rozmiaru"
}
